module.exports = __webpack_public_path__ + "static/media/didi.b61f6de.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audio/didi.mp3
// module id = oeSO
// module chunks = 1